import { JSX } from 'react';
import { HeroStatistics } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { GetHeroStatisticsModel } from './C52HeroStatistics.service';
import { C52HeroStatisticsProps } from './C52HeroStatistics.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C52HeroStatisticsProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = GetHeroStatisticsModel(props);

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName="HeroStatistics">
        <HeroStatistics
          id={props?.params?.AnchorLinkTargetName}
          className={translationClasses(props?.params)}
          {...model}
        />
      </SwitchToPreviewMessage>
    );
  }

  return (
    <HeroStatistics
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C52HeroStatisticsProps>(Default);
